import { createSelector } from 'reselect'

export const selectPonr = state => state.ponr

export const selectPonrReached = createSelector(
  selectPonr,
  ponr => ponr.reached,
)
